<app-loader></app-loader>
<div class="iguau-perfil-shell">
  <div *ngIf="perfil.ID != undefined">
    <app-perfil-show [misdatos]="misdatos" [perfil]="perfil"></app-perfil-show>
    <!--<app-perfil-hablamos [misdatos]="misdatos" [perfil]="perfil" *ngIf="!editandoperfil"></app-perfil-hablamos>-->
  </div>
  <div
    class="iguau-profile-loading"
    *ngIf="busy > 0 || !perfil || !perfil.ID"
  >
    <div class="spinner-border text-iguau" role="status">
      <span class="visually-hidden">Cargando perfil...</span>
    </div>
  </div>
</div>
